import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatDate } from "../../formatters/formatDate";
export const FormatDate = (props)=>{
    const formattedValue = formatDate(props.value, props.options);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formattedValue
    });
};
FormatDate.displayName = 'FormatDate';

//# sourceMappingURL=FormatDate.js.map